import { Component } from '@angular/core';
import { IToasterInput, IToasterVariant } from '../model/interfaces';
import { Subscription } from 'rxjs';
import { InternalMsgService } from '../shared/internal.msg.service';

@Component({
    selector: 'app-toaster',
    templateUrl: `./toaster.component.html`
})
export class ToasterComponent {
    messagesQueue: IToasterInput[] = [];
    languageSubscr!: Subscription;
    hidden: string = 'hidden';

    constructor(private msgService: InternalMsgService) {
        this.msgService.showToasterSet$.subscribe( (input) => {
            input.toasterMessage = input.toasterMessage;
            this.messagesQueue.push(input);
            this.showToaster(input);
        });
    }

    showToaster( input: IToasterInput): void {
        this.hidden = '';
        setTimeout(() => {
            this.hideToaster(input);
        }, 
            input.toasterTimeoutMs
        );            
    }

    hideToaster(item: IToasterInput): void {
        this.messagesQueue = this.messagesQueue.filter( x => x != item );
    }

    getToasterBarColor(toasterVariant: string): string {
        if (toasterVariant == 'success') {
            return 'border-color: var(--tds-positive)';
        }
        if (toasterVariant == 'error') {
            return 'border-color: var(--tds-negative)';
        }
        if (toasterVariant == 'warning') {
            return 'border-color: var(--tds-warning)';
        }
        if (toasterVariant == 'information') {
            return 'border-color: var(--tds-information)';
        }
        return '';
    }
}

